// Note: All lodge link employees (+contractors) will be members of this org, but that doesn't
// mean they're necessarily an admin.
// const AdminOrg = 'LodgeLink';
// Set this to false to for blissful silence
const beLoud = false;

/**
 * Search all linked orgs for the admin org (doesn't have to be `activeOrganization`)
 * @param {*} me
 * @returns
 */
// function getAdminOrg(me) {
//   // eslint-disable-line no-unused-vars
//   if (!me) return undefined;
//   // me.organizations:object[]
//   // me.activeOrganization:object
//   for (let i = 0; i < me.organizations.length; i += 1) {
//     if (me.organizations[i].name === AdminOrg) {
//       return me.organizations[i];
//     }
//   }
//   return undefined;
// }

export class UserCtxData {
  privateData = {};

  constructor(userId, firstName, lastName, isAdmin, permissions = []) {
    this.privateData.userId = userId;
    this.privateData.firstName = firstName ?? ''; // Make sure it's not null
    this.privateData.lastName = lastName ?? ''; // Make sure it's not null
    this.privateData.isAdmin = isAdmin;

    // Keep this as an array, it requires o(n) lookup, but so does object-key lookup (apparently.. it's hard
    // to find definitive documents online).  And the hash cost rarely benefits with small lists of data (eg  <1000 items)
    this.privateData.permissions = permissions;

    this.privateData.log =
      process.env.NODE_ENV && process.env.NODE_ENV === 'development' && beLoud
        ? // eslint-disable-next-line no-console
          (...str) => console.log(...str)
        : () => {};
  }

  /**
   * User ID
   * @returns {string}
   */
  get userId() {
    return this.privateData.userId;
  }

  /**
   * User initials, supports users with only one name (first or last)
   * Returns '??' if they have no names
   * @returns {string}
   */
  get initials() {
    let ret = '';
    if (this.privateData.firstName.length > 0) ret += this.privateData.firstName[0];
    if (this.privateData.lastName.length > 0) ret += this.privateData.lastName[0];
    return ret.length === 0 ? '??' : ret;
  }

  /**
   * User full name, supports users with only one name (first or last)
   * Returns '' (empty string) if they have no names
   * @returns {string}
   */
  get name() {
    const ret = [];
    if (this.privateData.firstName.length > 0) ret.push(this.privateData.firstName);
    if (this.privateData.lastName.length > 0) ret.push(this.privateData.lastName);
    return ret.join(' ');
  }

  /**
   * Whether this user is an admin
   * @returns {boolean}
   */
  get isAdmin() {
    return this.privateData.isAdmin;
  }

  /**
   * Log (to console, Analytics)
   */
  get log() {
    return this.privateData.log;
  }

  /**
   * Whether this user has the specified permission (case-sensitive)
   * @param {string} permission
   * @returns {boolean}
   */
  hasPermission(requestedPermission) {
    if (!requestedPermission || !this.privateData.permissions) return false;
    return this.privateData.permissions.some((hasPermission) => hasPermission === requestedPermission);
  }

  /**
   * Whether access is permitted
   * @param {string|undefined} reqPermission Name of required permission, if empty only @see and is used
   * @param {boolean|undefined} and Further constraint (ignored if undefined)
   * @param {boolean|undefined} isOr Whether to use OR instead of AND (default to AND if undefined)
   * @returns {boolean}
   */
  allow(reqPermission, and = true, isOr = false) {
    const permissionRequested = reqPermission !== undefined;
    // If no permission is requested.. permitted can be considered true
    if (Array.isArray(reqPermission)) {
      let permitted;
      if (!permissionRequested) return and;
      if (isOr) {
        permitted = false;
        reqPermission.forEach((reqPerm) => {
          if (this.hasPermission(reqPerm)) {
            permitted = true;
          }
        });
      } else {
        permitted = true;
        reqPermission.forEach((reqPerm) => {
          if (!this.hasPermission(reqPerm)) {
            permitted = false;
          }
        });
      }
      return permitted && and;
    }
    const permitted = permissionRequested ? this.hasPermission(reqPermission) : true;
    return permitted && and;
  }

  /**
   * Whether access should be prevent (inverse of @see allow ) a reason will be returned if access
   * is denied.  So convert to boolean use `const allow=denyReason(hasPermission,and)===undefined;`
   * @param {string|undefined} reqPermission
   * @param {boolean|undefined} and Further constraint (ignored if undefined)
   * @returns {string|undefined}
   */
  denyReason(reqPermission, and = true) {
    const permissionRequested = reqPermission !== undefined;
    // If no permission is requested.. permitted can be considered true
    const permitted = permissionRequested ? this.hasPermission(reqPermission) : true;
    // Todo: Probably don't want this detail, but helps during dev
    if (!permitted) return `Unauthorized - ${this.privateData.firstName} missing permission ${reqPermission}`;
    if (!and) return `Unauthorized`;
    return undefined;
  }

  static empty() {
    return new UserCtxData('', '', '', false);
  }

  static fromMe(me) {
    if (!me) return UserCtxData.empty();
    // me?.emailAddress: string

    // For now, we'll continue to use the admin flag to override membership in the org (since being in the org
    // doesn't necessarily mean they're an admin, but all admins must be in the org)
    if (me.admin) {
      // Search for admin org (allows user to stay in current org and still use portal)
      // const org = getAdminOrg(me);
      // Use current org (requires user to switch to LL org for support-admin usage)
      const org = me.activeOrganization;
      if (org) {
        return new UserCtxData(me.userId, me.firstName, me.lastName, me.admin, org.permissions);
      }
    }
    return new UserCtxData(me.userId, me.firstName, me.lastName, me.admin);
  }
}
